module.exports = __webpack_public_path__ + "img/security.004a2cf7.svg";